import { render, staticRenderFns } from "./TingkatKesehatanPerusahaan.vue?vue&type=template&id=f712c8cc"
import script from "./TingkatKesehatanPerusahaan.vue?vue&type=script&lang=js"
export * from "./TingkatKesehatanPerusahaan.vue?vue&type=script&lang=js"
import style0 from "./TingkatKesehatanPerusahaan.vue?vue&type=style&index=0&id=f712c8cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports